// Point value → badge color, matching the mobile app (getPointColor).
export const POINT_COLORS = {
  100: "#4CAF50", // green
  200: "#2196F3", // blue
  300: "#FF9800", // orange
  400: "#E91E63", // pink
  500: "#9C27B0", // purple
};

export const getPointColor = (points) => POINT_COLORS[points] || "#647AAA";
